export const getErrorMessage = (fieldError: unknown): string | undefined => {
  if (typeof fieldError === 'string') {
    return fieldError;
  }

  if (
    typeof fieldError === 'object' &&
    fieldError !== null &&
    'message' in fieldError &&
    typeof fieldError.message === 'string'
  ) {
    return fieldError.message;
  }

  return undefined;
};
